import tourvisorAPI from '../../api/tourvisorAPI';
import { OneHotTourViewForHotToursPage } from '../views/OneHotTourViewForHotToursWidget/OneHotTourViewForHotToursWidget';
import s from './searchHotTourWidget.module.css';
import React, { useEffect, useState } from 'react';
import GeoProgressBar from '../../../shared/components/GeoProgressBar';
import Select from '@mui/material/Select';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import DEPART_CITY_DIC from '../constants/DepartCity';
import './stylesForSelect.css';

const parseDate = (dateString) => {
  const parts = dateString.split('.');
  return new Date(parts[2], parts[1] - 1, parts[0]);
};

const SearchHotTourWidget = ({
  GLOBAL,
  DEPART_DATA,
  DEFAULT_DEPART,
  COUNTRY_DIC,
  PAGE,
}) => {
  const countriesIDString =
    GLOBAL.TOURS_REQUEST?.request?.map((el) => el.countryId).join(',') ||
    '1,47';
  const blackListArrayString = GLOBAL.TOUROPERATORS_EXCLUDED.map((el) => el.id);

  const [departCityCode, setDepartCityCode] = useState(DEPART_DATA.id);
  const [tours, setTours] = useState([]);
  const [filterValues, setFilterValues] = useState('all');
  const [filterredTours, setFilterrredTours] = useState([]);
  const [sort, setSort] = useState('');
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState(countriesIDString);
  const [showMore, setShowMore] = useState(false);
  const countryNames = countriesIDString
    .split(',')
    .map((el) => ({ name: COUNTRY_DIC[el].name, id: el }));

  useEffect(() => {
    setLoading(true);
    tourvisorAPI.dics('operator').then((res) => {
      const allOperatorsArray = res.lists.operators.operator.map((el) => el.id);
      const filteredOperatorsIdwithBlackList = allOperatorsArray.filter(
        (el) => {
          return !blackListArrayString.some((item) => item === el);
        }
      );

      const operatorsWithBlackListString = filteredOperatorsIdwithBlackList
        .sort((a, b) => a - b)
        .join(',');
      tourvisorAPI
        .hot(
          `sort=${sort}&operators=${operatorsWithBlackListString}&items=100&city=${departCityCode}&countries=${countries}`
        )
        .then((res) => {
          if (res.hottours.hotcount === 0 && departCityCode === DEPART_DATA.id) {
            setDepartCityCode(DEFAULT_DEPART.id);
          }

          if (res.hottours.hotcount === 0) {
            setTours([]);
            setFilterrredTours([]);
          } else {
            setTours(res.hottours.tour);
            setFilterrredTours(res.hottours.tour);
          }
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }, [countries, departCityCode]);

  let toursRender = (
    <div className={s.tours}>
      {filterredTours.slice(0, 48).map((t) => (
        <OneHotTourViewForHotToursPage
          GLOBAL={GLOBAL}
          key={t.tourid}
          tour={t}
        />
      ))}
      {showMore &&
        filterredTours
          .slice(49, 101)
          .map((t) => (
            <OneHotTourViewForHotToursPage
              GLOBAL={GLOBAL}
              key={t.tourid}
              tour={t}
            />
          ))}
    </div>
  );
  const changeCountryHandler = (e) => {
    setCountries(e.target.value);
    setShowMore(false);
    setSort('1');
    setFilterValues('all');
  };

  const changeDepartCityHandler = (e) => {
    setDepartCityCode(e.target.value);
    setFilterValues('all');
  };

  const changeSortHandler = (e) => {
    if (e.target.value === '1') {
      setFilterrredTours(tours.sort((a, b) => +a.price - +b.price));
    }

    if (e.target.value === 'discount') {
      setFilterrredTours(tours.sort((a, b) => b.volatility - a.volatility));
    }

    if (e.target.value === 'time') {
      setFilterrredTours(
        tours.sort((a, b) => parseDate(a.flydate) - parseDate(b.flydate))
      );
    }
    setSort(e.target.value);
    setFilterValues('all');
  };
  const changeNightsHandler = (e) => {
    if (e.target.value === 'all') {
      setFilterrredTours(tours);
      setFilterValues(e.target.value);
      return;
    }

    const minMaxArr = e.target.value.split('-').map((el) => +el);
    setFilterrredTours(
      tours.filter(
        (tours) =>
          +tours.nights >= minMaxArr[0] && +tours.nights <= minMaxArr[1]
      )
    );
    setFilterValues(e.target.value);
  };
  return (
    <div className={s.toursContainer}>
      <div className={s.fields}>
        <FormControl fullWidth style={{ maxWidth: '140px' }}>
          <InputLabel id="demo-simple-select-label">Город вылета</InputLabel>
          <Select
            value={departCityCode}
            label="Город вылета"
            onChange={changeDepartCityHandler}
          >
            {Object.values(DEPART_CITY_DIC)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((el) => (
                <MenuItem key={el.id} title={el.name} value={el.id}>
                  {el.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl fullWidth style={{ maxWidth: '140px' }}>
          <InputLabel id="demo-simple-select-label">Страна</InputLabel>
          <Select label="Страна" onChange={changeCountryHandler}>
            {countryNames.map((el) => (
              <MenuItem key={el.id} title={el.name} value={el.id}>
                {el.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth style={{ maxWidth: '140px' }}>
          <InputLabel id="demo-simple-select-label">Сортировка</InputLabel>
          <Select value={sort} label="Сортировка" onChange={changeSortHandler}>
            <MenuItem value="1">По цене</MenuItem>
            <MenuItem value="discount">По скидке</MenuItem>
            <MenuItem value="time">По дате вылета</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth style={{ maxWidth: '140px' }}>
          <InputLabel id="demo-simple-select-label">Длительность</InputLabel>
          <Select
            value={filterValues}
            label="Длительность"
            onChange={changeNightsHandler}
          >
            <MenuItem value="all">Все туры</MenuItem>
            <MenuItem value="2-5">2-5 ночей</MenuItem>
            <MenuItem value="6-9">6-9 ночей</MenuItem>
            <MenuItem value="10-14">10-14 ночей</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className={s.progressBarContainer}>
        <GeoProgressBar in_progress={loading} />
      </div>
      {filterredTours.length > 0 ? (
        toursRender
      ) : (
        <div className={s.description}>
          Туров по выбранным критериям не найдено
        </div>
      )}
      {!showMore && filterredTours.length > 50 && (
        <button className={s.buttonShowMore} onClick={() => setShowMore(true)}>
          Показать еще
        </button>
      )}
    </div>
  );
};

export default SearchHotTourWidget;